import * as types from "./cmsActionType";

const initialState = {
    cmsPlaceList: [],
}
const CmsReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.CMS_PLACE_LIST:
            return {
                ...state,
                cmsPlaceList: [...action.payload]
            }
        default:
            return state;
    }
}
export default CmsReducer;